export default __webpack_public_path__ + "static/media/feb-brand.19df6661.png";